import React, { Fragment, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import { Tooltip } from '@mui/material';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';


const CategoryCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    // Logout if token is expired
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, token, logout]);


    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [gstError, setGstError] = useState('');

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        RawmaterialCode: '',
        Name: '',
        Rate: '0',
        GSTRate: '0',
        CGSTRate: '',
        SGSTRate: '',
        Description: '',
        HSNCode: '',
        OpeningStock: '0',
        MinimumStock: '0',
        CreatedBy: userId,
        CreatedDate: new Date().toISOString(),
    });

    // const handleChange = (event) => {
    //     const { name, value, type } = event.target;
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: type === 'checkbox' ? !prevData[name] : value,
    //     }));
    // };
    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedFormData = { ...formData, [name]: value };

        setFormData(updatedFormData);

        // Validation: CGST and SGST must be equal
        if (
            name === 'CGSTRate' || name === 'SGSTRate'
        ) {
            if (
                updatedFormData.CGSTRate !== '' &&
                updatedFormData.SGSTRate !== '' &&
                parseFloat(updatedFormData.CGSTRate) !== parseFloat(updatedFormData.SGSTRate)
            ) {
                setGstError('CGST and SGST rates must be equal');
            } else {
                setGstError('');
            }
        }
    };

    const submitData = async () => {
        try {
            // Fetch existing data
            const existingItems = await fetchData('CategoryApi', `/${companyId}`, token);
            console.log('Existing Items:', existingItems);

            if (
                existingItems.response_data &&
                Array.isArray(existingItems.response_data) &&
                existingItems.response_data.some(
                    (item) => item.Name === formData.Name
                )
            ) {
                alert('Item with the same Name already exists.');
                return;
            }
            if (parseFloat(formData.CGSTRate) !== parseFloat(formData.SGSTRate)) {
                alert('CGST and SGST rates must be equal');
                return;
            }
            // Validate form data
            if (!formData.Name) {
                alert('Name is required.');
                return;
            }

            if (!formData.CGSTRate) {
                alert('CGST Rate is required.');
                return;
            }

            if (!formData.SGSTRate) {
                alert('SGST Rate is required.');
                return;
            }

            if (!formData.HSNCode) {
                alert('HSN Code is required.');
                return;
            }

            // Submit data
            const response = await postData('CategoryApi', formData, token);
            console.log('Data Created success:', response);

            history.push('/CategoryIndex');
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%' }}>

                <div className='w-full mb-2 flex' style={{ marginTop: '-30px' }}>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Category Create</h6>


                    <Button

                        style={{
                            background: 'linear-gradient(to right,rgb(94, 179, 138),rgb(98, 150, 61))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',

                        }}
                        onClick={submitData}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <span>Save</span>}
                    </Button>

                    <Button

                        component={Link}
                        to="/CategoryIndex"
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right,rgb(162, 31, 31),rgb(223, 91, 70))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',

                        }}
                    >
                        Cancel
                    </Button>

                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                <div className="w-full flex flex-wrap">
                    <div className="w-full" style={{ padding: '7px', borderRadius: '10px' }}>
                        <div className="w-full mb-3 flex" >

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Name<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Name}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Name"
                                    name='Name'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' }}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    HSN Code<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.HSNCode}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="HSN Code"
                                    name='HSNCode'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' }}
                                />
                            </div>
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    CGST Rate<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.CGSTRate}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="CGST Rate"
                                    name='CGSTRate'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px', textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    SGST Rate<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.SGSTRate}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="SGST Rate"
                                    name='SGSTRate'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px', textAlign: 'right' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </Fragment >
    );
};

export default CategoryCreate;

